var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.800781 2.98193C0.800781 1.87736 1.69621 0.981934 2.80078 0.981934H9.80078C10.9054 0.981934 11.8008 1.87736 11.8008 2.98193V8.98193C11.8008 10.0865 10.9054 10.9819 9.80078 10.9819H2.80078C1.69621 10.9819 0.800781 10.0865 0.800781 8.98193V2.98193ZM2.61436 7.85528L4.12538 6.45399L4.91852 7.18953C5.10214 7.35981 5.41072 7.35981 5.59434 7.18953L6.27973 6.55392L7.28073 5.62562L8.1542 6.43566C8.33782 6.60594 8.6464 6.60594 8.83002 6.43566L10.4335 4.94862L10.663 4.73577C10.8403 4.57141 10.853 4.26986 10.663 4.10903C10.4717 3.94644 10.1753 3.93283 9.9872 4.10903L8.49211 5.49555L7.61864 4.68551C7.43501 4.51522 7.12643 4.51522 6.94281 4.68551L6.25743 5.32112L5.25643 6.24942L4.46329 5.51388C4.27967 5.34359 3.97109 5.34359 3.78747 5.51388L1.93854 7.22854C1.7613 7.3929 1.74854 7.69445 1.93854 7.85528C2.12981 8.01728 2.42565 8.03089 2.61436 7.85528Z",
    fill: "#4CF3A8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/ChartIcon.2b3edf90e68a4bd3e86e5852fb57a0c1.svg";
export { ForwardRef as ReactComponent };